<script setup lang="ts">
import { RouterView, useRoute } from 'vue-router';
import HeaderPrimary from './components/layout/HeaderPrimary.vue';
import FooterPrimary from './components/layout/FooterPrimary.vue';
import { ref, watch, onMounted } from 'vue';
import { useCommonStore } from './stores/common';

const route = useRoute();
const backToTop = ref();
const commonStore = useCommonStore();
declare const config: any;

    onMounted(async () => {
        await commonStore.fetchGlobalFeatures();
        const isQuantumMetricEnabled = commonStore.globalFeatures.get('CorporatePortal.IsQuantumMetricEnabled') ?? false;

        if (isQuantumMetricEnabled) {
            const quantumMetricScript = document.createElement('script');
            quantumMetricScript.async = true;
            quantumMetricScript.src = config?.QUANTUM_METRIC_SCRIPT;
            document.head.appendChild(quantumMetricScript);

            const quantumMetricInterceptorScript = document.createElement('script');
            quantumMetricInterceptorScript.src = config?.QUANTUM_METRIC_INTERCEPTOR;
            quantumMetricInterceptorScript.crossOrigin = 'anonymous';
            document.head.appendChild(quantumMetricInterceptorScript);
        }
    });


// This function watches for the route's path to change.
watch(
    () => route.path, // The source to watch: the current route's path
    () => {
        // The callback function to execute when the path changes
        backToTop.value?.focus(); // This specifically fixes the focus so that the skip link is always the next item tabbed to
        // This should not be necessary, but just in case, if the beforeRoute function fails, this will attempt to set the title.
        if (route.meta !== undefined && route.meta.title !== undefined && typeof route.meta.title === 'string' && route.meta.title.length > 0) {
            document.title = route.meta.title as string;
        }
    }
)
</script>

<template>
    <div class="container-body">
        <span ref="backToTop" tabindex="-1" />
        <a href="#skipToContent" class="visually-hidden-focusable" ref="skipLink"> Skip to main content </a>
        <HeaderPrimary />

        <RouterView />

        <FooterPrimary />
    </div> 
</template>

<style scoped></style>
